/*
 * Updates the Font Awesome FB icon in elementor share widget
 */
jQuery (function () {
    jQuery ('.elementor-share-btn.elementor-share-btn_facebook .fab').removeClass ('fa-facebook');
    jQuery ('.elementor-share-btn.elementor-share-btn_facebook .fab').addClass ('fa-facebook-f');
});